/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContactForDisplayFromJSON, ContactForDisplayToJSON } from './ContactForDisplay';
import { ViewHistoryGraphObjectFromJSON, ViewHistoryGraphObjectToJSON } from './ViewHistoryGraphObject';
export function GetDocumentViewHistoriesGraphResponseDataFromJSON(json) {
    return GetDocumentViewHistoriesGraphResponseDataFromJSONTyped(json, false);
}
export function GetDocumentViewHistoriesGraphResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contact: !exists(json, 'contact') ? undefined : ContactForDisplayFromJSON(json['contact']),
        graphObjects: !exists(json, 'graph_objects')
            ? undefined
            : json['graph_objects'].map(ViewHistoryGraphObjectFromJSON),
        startedAt: !exists(json, 'started_at') ? undefined : json['started_at']
    };
}
export function GetDocumentViewHistoriesGraphResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact: ContactForDisplayToJSON(value.contact),
        graph_objects: value.graphObjects === undefined
            ? undefined
            : value.graphObjects.map(ViewHistoryGraphObjectToJSON),
        started_at: value.startedAt
    };
}
